export const ModuleName = 'EmailTemplates';
export const ResourceModule = 'ResourceModule';
export const IdToken = "IdToken";
